import { TextField } from "@mui/material";
import React, { useState } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { useEffect } from "react";
import { ValidaContacto } from "./ValidaContacto";
import { useSelector } from "react-redux";

export const ModalContactoNew = ({ orden, setContactos, mediocontacto }) => {
  const { idcliente } = useSelector((store) => store.clientes);
  const [contactosRegistrados, setContactosRegistrados] = useState();
  const closedModal = () => {
    var modal = document.getElementById("modal-contacto-new");
    modal.style.display = "none";
    // mediocontacto = "";
  };
  const [state, setState] = useState({
    mediocontacto: "",
    tipocontacto: "",
    valor: "",
    comentarios: "",
  });
  const [medios, setMedios] = useState({
    idcliente: idcliente,
    medio: mediocontacto,
    cobranza: "",
    credito: "",
    ventas: "",
    posventas: "",
  });
  // console.log(medios)
  useEffect(() => {
    if (
      idcliente === undefined ||
      idcliente === null ||
      idcliente === 0 ||
      idcliente === "0" ||
      idcliente === "" ||
      idcliente === "-1" ||
      idcliente === "-1"
    ) {
      return;
    }
    request
      .get(
        `ClientesDatosContacto/ListadoContactosRegistrados?idcliente=${Number(
          idcliente
        )}&mediocontacto=${mediocontacto}`
      )
      .then((result) => {
        setContactosRegistrados(result);
      })
      .catch((error) => {
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  }, [idcliente, mediocontacto]);

  useEffect(() => {
    if (!contactosRegistrados || !Array.isArray(contactosRegistrados)) return;

    const nuevosMedios = {
      medio: mediocontacto,
      cobranza: "",
      credito: "",
      ventas: "",
      posventas: "",
    };

    contactosRegistrados.forEach((contacto) => {
      switch (contacto.tipo_contacto) {
        case "CO": // cobranza
          nuevosMedios.cobranza = contacto.valor || "";
          break;
        case "CR": // crédito
          nuevosMedios.credito = contacto.valor || "";
          break;
        case "VE": // ventas
          nuevosMedios.ventas = contacto.valor || "";
          break;
        case "PO": // posventa
          nuevosMedios.posventas = contacto.valor || "";
          break;
        default:
          break;
      }
    });

    setMedios(nuevosMedios);
  }, [contactosRegistrados, mediocontacto]);

  const onGuardar = async () => {
    const comentariosFijos = "";

    const contactoPorDepto = [
      { key: "cobranza", tipo: "CO" },
      { key: "credito", tipo: "CR" },
      { key: "ventas", tipo: "VE" },
      { key: "posventas", tipo: "PO" },
    ];

    const defaultValor = contactoPorDepto.reduce((acc, { key }) => {
      const val = medios[key]?.trim();
      return acc || (val ? val.toUpperCase() : "");
    }, "");

    if (!defaultValor) {
      Swal.fire(
        "Validación",
        "Debes ingresar al menos un medio de contacto",
        "warning"
      );
      return;
    }

    const contactosValidados = [];
    for (const { key, tipo } of contactoPorDepto) {
      const valor = medios[key]?.trim() || defaultValor;

      const stateTemporal = {
        mediocontacto: key,
        tipocontacto: tipo,
        valor: valor.toUpperCase(),
        comentarios: comentariosFijos,
      };

      const valido = ValidaContacto(stateTemporal);
      if (!valido) {
        Swal.fire(
          "Validación",
          `El valor ingresado en ${key.toUpperCase()} no es válido`,
          "error"
        );
        return;
      }

      contactosValidados.push({
        ...valido,
        idcliente: Number(idcliente),
        orden: orden,
        medio_contacto: mediocontacto,
        tipo_contacto: tipo,
        comentarios: comentariosFijos,
        valor: valor.toUpperCase(),
      });
    }

    try {
      const resultados = await Promise.all(
        contactosValidados.map((contacto) =>
          request.post("ClientesDatosContacto", contacto)
        )
      );

      const ultimoResultado = resultados[resultados.length - 1];
      await Swal.fire(
        "Clientes",
        "Contactos guardados correctamente",
        "success"
      );

      setContactos(ultimoResultado.listado);
      closedModal();
    } catch (error) {
      Swal.fire("Clientes", JSON.stringify(error), "error");
    }
  };

  useEffect(() => {
    if (orden !== undefined && orden !== null && Number(orden) > 0) {
      request
        .get(
          `ClientesDatosContacto/BuscarID?idcliente=${Number(
            idcliente
          )}&orden=${Number(orden)}`
        )
        .then((result) => {
          setState({
            mediocontacto: result.medio_contacto,
            tipocontacto: result.tipo_contacto,
            valor: result.valor,
            comentarios: result.comentarios,
          });
        })

        .catch((error) => {
          Swal.fire("Clientes", JSON.stringify(error), "error");
        });
    }
  }, [orden]);
  const capitalizeWords = (str) => {
    return str
      ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
      : "";
  };
  return (
    <div id="modal-contacto-new" class="modal">
      <div class="modal-content-clientes">
        <div class="modal-header-contacto">
          <span class="close" onClick={closedModal}>
            &times;
          </span>
          <div className="encabezado">
            <div className="titulo">
              {orden === 0 ? "REGISTRAR CONTACTO" : "ACTUALIZAR CONTACTO"}
            </div>
            <div className="border-green"></div>
          </div>
        </div>
        <div class="modal-body-clientes">
          <TextField
            fullWidth
            label="Cobranza"
            size="small"
            color="success"
            value={medios.cobranza}
            onChange={({ target }) =>
              setMedios({
                ...medios,
                cobranza: target.value.toUpperCase(),
              })
            }
            inputProps={{
              maxLength: 500,
            }}
          />
          <TextField
            fullWidth
            label="Credito"
            sx={{ mt: 2 }}
            size="small"
            color="success"
            value={medios.credito}
            onChange={({ target }) =>
              setMedios({
                ...medios,
                credito: target.value.toUpperCase(),
              })
            }
            inputProps={{
              maxLength: 500,
            }}
          />
          <TextField
            fullWidth
            label="Ventas"
            size="small"
            color="success"
            sx={{ mt: 2 }}
            value={medios.ventas}
            onChange={({ target }) =>
              setMedios({
                ...medios,
                ventas: target.value.toUpperCase(),
              })
            }
            inputProps={{
              maxLength: 500,
            }}
          />
          <TextField
            fullWidth
            label="Posventa"
            size="small"
            color="success"
            sx={{ mt: 2 }}
            value={medios.posventas}
            onChange={({ target }) =>
              setMedios({
                ...medios,
                posventas: target.value.toUpperCase(),
              })
            }
            inputProps={{
              maxLength: 500,
            }}
          />
        </div>
        <div className="footer-guardar-domicilio">
          <div className="button-guardar" onClick={onGuardar}>
            Guardar
          </div>
        </div>
      </div>
    </div>
  );
};
